import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const US_DATE_FORMAT = 'DD MMM YYYY';
export const US_SHORT_DATE_FORMAT = 'DD MMM';

export function getUtcDateTime() {
  return dayjs.utc();
}

export function formatToUtcDate(date: Date | string | Dayjs) {
  return dayjs.utc(date).toISOString();
}

export function getUtcDate(date: Date | string | Dayjs) {
  return dayjs.utc(date);
}

export function getFormattedUtcDateTime(date: Date | string | Dayjs) {
  return dayjs.utc(date).format(`${US_DATE_FORMAT}, h:mma`);
}

export function getUSTimeFormat(
  date: Date | string | Dayjs,
  isLongDateFormat = true,
  isUtc = false
) {
  const format = isLongDateFormat ? US_DATE_FORMAT : US_SHORT_DATE_FORMAT;

  if (isUtc) {
    return getUtcDate(date).format(format);
  }

  return dayjs(date).format(format);
}

export function getStartOfDate(date: Dayjs) {
  return date
    .set('hour', 0)
    .set('minute', 0)
    .set('second', 0)
    .set('millisecond', 0);
}
